<template>
	<div class="md-grey-page applicant-update center-horizontal">
		<div class="page-banner"></div>
		<div class="container-white">
			<div class="add-page">

				<h2 class="page__main-title applicant-update__title">{{companyName}}</h2>

				<div v-if="!loaded">
					Preparing your registration form...
				</div>

				<div v-if="loaded">

					<!-- Stage 1 -->
					<section v-if="applicant.stage == 1">
						<div class="mdc-layout-grid mdc-layout-grid__inner">
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop">
								<p class="text-left">{{ applicant.fullName }}’s search criteria:</p>
							</div>
						</div>
						<section class="subsection-serviceType">
							<option-buttons v-model="applicant.serviceType" :items="[[1, 'BUY'],[2, 'RENT']]" title="I need to" :cols="2" @changed="dataChanged"></option-buttons>
						</section>
						<section class="subsection-bedrooms">
							<option-buttons v-model="applicant.bedrooms" :items="[[0,'Studio'],[1, '1 bedroom'],[2, '2 bedrooms'],[3, '+']]" title="a" :cols="2" @changed="dataChanged"></option-buttons>
							<option-buttons v-model="applicant.bedrooms" :items="[[3, '3 bedrooms'],[4, '4 bedrooms'],[5, '5 bedrooms'],[6, '6 bedrooms'],[7, '7 bedrooms']]" title="" :cols="2" @changed="dataChanged" v-if="applicant.bedrooms > 2"></option-buttons>
						</section>

						<section class="subsection-type">
							<option-buttons v-model="applicant.type" :items="[['flat', 'Flat'],['house', 'House'],['either', 'Either']]" title="" :cols="3" @changed="dataChanged"></option-buttons>
						</section>

						<section class="subsection-budget">
							<div class="mdc-layout-grid mdc-layout-grid__inner">
								<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop">
									<h3 class="text-center">Up to</h3>
								</div>
								<currency-input class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop applicant-update__budget" v-model="applicant.budget" placeholder="£ Budget" label="" @newValue="priceChanged"></currency-input>
								<span v-if="applicant.serviceType == 2" class="text-center">PCM</span>
							</div>
						</section>

						<div class="mdc-layout-grid">
							<button class="mdc-button mdc-button--raised" @click="applicant.stage += applicant.email == '' || applicant.mobile == '' ? 1 : 2">SUBMIT</button>
						</div>
					</section>

					<!-- Stage 2 -->
					<section v-if="applicant.stage == 2">
						<div v-if="applicant.email == ''">
							<p class="text-left">Thanks.<br>Next, please can we have your email address for messaging:</p>
							<div class="width-100 mdc-textfield mdc-textfield--upgraded mdc-textfield__no-margin-top">
								 <input id="email" type="text" v-model="tempEmail" class="mdc-textfield__input" name="email">
								 <label for="email" class="mdc-textfield__label mdc-textfield__label--float-above">Email</label>
							</div>
						</div>

						<div v-if="applicant.mobile == ''">
							<p class="text-left">Thanks.<br>Next, please can we have your mobile number for messaging:</p>
							<div class="width-100 mdc-textfield mdc-textfield--upgraded mdc-textfield__no-margin-top">
								 <input id="mobile" type="tel" v-model="tempMobile" class="mdc-textfield__input" name="mobile" inputmode="numeric" pattern="[0-9]*">
								 <label for="mobile" class="mdc-textfield__label mdc-textfield__label--float-above">Mobile Number</label>
							</div>
						</div>

						<div class="error" v-if="confirmationError != ''">{{confirmationError}}</div>

						<div class="mdc-layout-grid">
							<button class="mdc-button mdc-button--raised applicant-update__button" @click="confirmContact">SUBMIT</button>
							<a class="applicant-update__skip-btn" @click="applicant.stage += 1;">Skip</a>
						</div>
					</section>

					<!-- Stage 3 -->
					<section v-if="applicant.stage == 3">
						<p class="text-left">Thank you.<br>If you have time please give us your current address:</p>

						<editable-address v-model="applicant.address" :isEditView="true" :options="{attentionSymbol: false, startOnManual: hasAddress, goManualOnSuccess: true}" @changed="dataChanged"></editable-address>

						<div class="mdc-layout-grid">
							<button class="mdc-button mdc-button--raised applicant-update__button" @click="applicant.stage += 1">SUBMIT</button>
							<a class="applicant-update__skip-btn" @click="applicant.stage += 1;">Skip</a>
						</div>
					</section>

					<!-- Stage 4 -->
					<section v-if="applicant.stage == 4">
						<p class="text-left">Please tell us your current situation:</p>

						<section v-if="applicant.serviceType == 1">
							<option-buttons v-model="applicant.situation" :items="[['renting', 'Renting'],['property-to-sell', 'Property to Sell'], ['buy-to-let-investor', 'Buy-to-let Investor'], ['developer', 'Developer'], ['other', 'Other']]" title="" :cols="1" @changed="dataChanged"></option-buttons>
							<div v-if="applicant.situation == 'property-to-sell'">
								Property to sell...
								<option-buttons v-model="applicant.propertyToSell" :items="[['on-market', 'On market'],['not-yet-on-market', 'Not yet on market'], ['sale-agreed', 'Sale agreed']]" title="" :cols="2" @changed="dataChanged"></option-buttons>
							</div>
						</section>

						<section v-if="applicant.serviceType == 2">
							<p>I need to move...</p>
							<option-buttons v-model="applicant.situation" :items="[['urgently', 'Urgently'],['2-weeks', 'Within 2 weeks'], ['1-month', 'In one month'], ['1-3-months', 'In 1 to 3 months'], ['more-3-months', 'Not for at least 3 months']]" title="" :cols="3" @changed="dataChanged"></option-buttons>
						</section>

						<div class="mdc-layout-grid">
							<button class="mdc-button mdc-button--raised applicant-update__button" @click="applicant.stage += 1">SUBMIT</button>
							<a class="" @click="applicant.stage += 1;">Skip</a>
						</div>
					</section>

					<!-- Stage 5 -->
					<section v-if="applicant.stage == 5">
						<p class="text-left">Please tell us anything else you think would be useful for us to know about your intended move.</p>

						<textarea class="width-100 description-textarea" v-model="applicant.comments" placeholder="" rows="4"></textarea>

						<div class="mdc-layout-grid">
							<button class="mdc-button mdc-button--raised applicant-update__button" @click="dataChanged(); applicant.stage += 1">SUBMIT</button>
							<a class="applicant-update__skip-btn" @click="applicant.stage += 1;">Skip</a>
						</div>
					</section>

					<!-- Stage 6 -->
					<section v-if="applicant.stage == 6">
						<p class="text-left">Please tell us about your availability to view suitable properties:</p>

						<option-buttons v-model="applicant.availability" :items="[['viewing', 'I\'m already viewing'],['ready', 'I\'m ready to view now'], ['browsing', 'I\'m just looking online for now']]" title="" :cols="1" @changed="dataChanged"></option-buttons>

						<div class="mdc-layout-grid">
							<button class="mdc-button mdc-button--raised applicant-update__button" @click="applicant.stage += 1; dataChanged();">SUBMIT</button>
							<!--a class="applicant-update__skip-btn" @click="applicant.stage += 1;">Skip</a-->
						</div>
					</section>

					<!-- Stage 7 -->
					<section v-if="applicant.stage == 7">
            <div class="mdc-layout-grid">
  						<p class="text-left">Thank you for registering with {{companyName}}. We will contact you as soon as any properties come to the market which you may wish to view.</p>
              <p class="text-left"><a v-if="siteUrl != ''" :href="siteUrl">{{ siteUrl }}</a></p>
            </div>
            <div class="mdc-layout-grid">
              <a class="applicant-update__skip-btn" @click="$router.push('/')" v-if="isAgent">< Back to BestAgent</a>
            </div>

					</section>

				</div>

			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import OptionButtons      from '../components/OptionButtons.vue';
import CurrencyInput      from '../components/CurrencyInput.vue';
import EditableAddress from '../components/editable-items/EditableAddress.vue';
import {isLoggedIn} from '@/libs/auth0.js';

export default {
	props: {
		email: {
			type: Boolean,
			default: false
		},
		mobile: {
			type: Boolean,
			default: false
		}
	},
	data: function() {
		return {
			loaded: false,
			companyName: '',
			applicant: {
				stage: 1,
				companyId: 0,
				applicantId: 0,
				fullName: '',
				email: '',
				mobile: '',
				serviceType: 0,
				bedrooms: 0,
        isStudio: false,
				type: '',
				budget: '',
				address: {},
				situation: '',
				propertyToSell: '',
				comments: '',
				availability: ''
			},
			siteUrl: "",
			showMoreBeds: false,
			tempEmail: '',
			tempMobile: '',
			confirmationError: '',
			hasAddress: false,
      isAgent: false
		}
	},
	components: {
		'option-buttons': OptionButtons,
		'currency-input': CurrencyInput,
		'editable-address': EditableAddress
	},
	created: async function() {
		let that = this;

		this.applicant.companyId = this.$route.params.companyId;
		this.applicant.applicantId = this.$route.params.applicantId;
		await axios.get(`${this.config.services.companies}/companySite/${this.applicant.companyId}`).then(function(response) {
			if (response.data && typeof response.data == 'string') {
				that.siteUrl = response.data;
			}
		}).catch(function(error) {
			console.error('error:', error);
		});
    // check if logged in
    if(await isLoggedIn()) {
  		this.isAgent = true;
  	}
    console.log(this.isAgent);

		// confirm email/mobile
		if(this.email || this.mobile) {
			let params = {
				companyId: this.$route.params.companyId,
				applicantId: this.$route.params.applicantId
			};
			if(this.email) {
				params.email = true;
			}
			if(this.mobile) {
				params.mobile = true;
			}
			axios.patch(`${this.config.services.applicants}/confirmContact`, params)
			.then(function(response) {
				console.log('ok');
			})
			.catch(function(error) {
				console.error('error:', error);
			});
		}

		// get latest applicant data
		axios.get(`${this.config.services.applicants}/details/${this.applicant.companyId}/${this.applicant.applicantId}`)
		.then(function(response) {
			that.applicant.stage = response.data.stage ? response.data.stage : 1;
			that.companyName = response.data.companyName;
			that.applicant.email = response.data.email ? response.data.email : '';
			that.applicant.fullName = response.data.fullName;
			that.tempEmail = that.applicant.email;
			that.applicant.mobile = response.data.mobile ? response.data.mobile : '';
			that.tempMobile = that.applicant.mobile;
			that.applicant.serviceType = response.data.serviceType;
			that.applicant.bedrooms = response.data.bedrooms;
			that.applicant.type = response.data.type;
			that.applicant.budget = response.data.budget;
			that.applicant.address = response.data.address ? response.data.address : {};
			that.applicant.situation = response.data.situation;
			that.applicant.propertyToSell = response.data.propertyToSell;
			that.applicant.comments = response.data.comments;
			that.applicant.availability = response.data.availability;

			if(that.applicant.address && that.applicant.address.street && that.applicant.address.street.length > 0) {
				that.hasAddress = true;
			}

			if(!response.data.consent) {
				that.dataChanged();
			}

			that.loaded = true;
		})
		.catch(function(error) {
			console.error('error:', error);
		});
	},
	methods: {
    toogleStudio(){
      this.applicant.isStudio = this.applicant.isStudio ? false : true;
    },
		dataChanged() {
			// save currend applicant data
			axios.patch(`${this.config.services.applicants}/update`, this.applicant)
			.then(function(response) {
				//console.log('ok');
			})
			.catch(function(error) {
				//console.error('error:', error);
			});
		},
		priceChanged(price) {
			this.applicant.budget = price;
			this.dataChanged();
		},
		confirmContact() {
			const that = this;

			this.confirmationError = '';

			let params = {
				companyId: this.applicant.companyId,
				applicantId: this.applicant.applicantId
			};
			if(this.applicant.email == '') {
				params.email = this.tempEmail;
			}
			if(this.applicant.mobile == '') {
				params.mobile = this.tempMobile;
			}

			// trigger confirm contact
			axios.patch(`${this.config.services.applicants}/sendConfirmation`, params)
			.then(function(response) {
				if(response.data.success) {
					that.applicant.email = that.tempEmail;
					that.applicant.mobile = that.tempMobile;
					that.applicant.stage += 1;
					that.dataChanged();
				} else {
					if(response.data.errorCode == 'email-exists') {
						that.confirmationError = 'Sorry, your email is already registered with us.';
					}
					if(response.data.errorCode == 'mobile-exists') {
						that.confirmationError = 'Sorry, your mobile number is already registered with us.';
					}
				}
			})
			.catch(function(error) {
				console.error('error:', error);
			});
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/Applicant-Update.vue